import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from "@sentry/angular";
import { environment} from '../../../environments/environment';
import { GlobalErrorService } from '../services/global-error.service';

@Injectable()
export class AppErrorHandler implements ErrorHandler {

  constructor(private readonly globalError: GlobalErrorService) {
  }

  handleError(error: unknown): void {
    this.globalError.handleUnexpectedError(error);
  }
}
